import { useState,useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import './filme.css'

import api from "../../services/api";


function Filme(){

const { id } = useParams();
const navigate= useNavigate();

const [filme,setFilme] = useState([]);
const [loading,setLoading] = useState(true);

useEffect(()=>{
    async function loadFilmes(){
    await api.get(`/movie/${id}`,{
        params:{
            api_key:"28fc232cc001c31e8a031f419d0a14ca",
            language: "pt-BR"
        }
    })
    .then((response)=>{
      setFilme(response.data)
      setLoading(false);
    })
     .catch(() =>{
      toast.sucess("Fil")
      navigate("/",{replace: true});
      return;
     })


    }

    loadFilmes();
},[])


   function salvarFilme(){
    const minhaLista = localStorage.getItem("@primeflix");

    let filmesSalvos = JSON.parse(minhaLista) || [];
    const hasFilme = filmesSalvos.some((filmesalvo)=> filmesalvo.id === filme.id)

    if(hasFilme){
      toast.warn("Esse filme ja esta na lista!")
      return;
    }
    filmesSalvos.push(filme);
    localStorage.setItem("@primeflix", JSON.stringify(filmesSalvos));
    toast.success("Filme Salvo na sua lista!")

   }




  if(loading){
    return(
        <div className="filme-info">
            <h1>Carregando Detalhes...</h1>
        </div>
    )
  }


    return(
        <div className="filme-info">
           <h1>{filme.title}</h1>
           <img src={`https://image.tmdb.org/t/p/original/${filme.backdrop_path}`}/>
           <h3>Sinopse</h3>
           <span>{filme.overview}</span>
           <strong>Avaliação: {filme.vote_average} /10</strong>

           <div className="area-btn">
             <button onClick={salvarFilme}>Salvar</button>
             <button>
               <a target="blank" rel="external" href={`https://youtube.com/results?search_query=${filme.title}`}>
                Trailer
               </a>
             </button>
           </div>
        </div>
    )
}
export default Filme;